/**
 * Shared semantic vocabulary for renderer and editor parity events.
 *
 * Phase pairs remain useful diagnostic context, but consumers should use these fields to decide
 * whether an event is ordinary timing mechanics or a rollout-significant divergence.
 */
export type RemixParitySeverity = 'info' | 'critical';

export type RemixParityOutcome =
	| 'timing-skew'
	| 'converged'
	| 'terminal-mismatch'
	| 'released-unresolved';

export type RemixParityReason =
	| 'phase-skew'
	| 'awaiting-convergence'
	| 'phase-converged'
	| 'terminal-outcome-mismatch'
	| 'legacy-not-tracking'
	| 'released-unresolved';

export type RemixParityDurationBucket = 'under-250ms' | '250-999ms' | '1-4s' | '5s-or-more';

export const durationBucketForMs = (durationMs: number): RemixParityDurationBucket => {
	if (durationMs < 250) {
		return 'under-250ms';
	}

	if (durationMs < 1000) {
		return '250-999ms';
	}

	if (durationMs < 5000) {
		return '1-4s';
	}

	return '5s-or-more';
};
